module.exports = __webpack_public_path__ + "media/images/gallery/constellations/scutum/sct_lines-209f21592dea3aae43e017c859c9f549.gif";